import { get } from 'lodash'
import { ACTIVITY_CATEGORIES } from 'constants/enums'

export default fields => {
  const schema = {
    ...fields,
    isMajor: Boolean(get(fields, 'isMajor')),
    helpers: undefined,
    activityCategory: {}
  }

  if (get(fields, 'activityCategory.id') === ACTIVITY_CATEGORIES.other.id) {
    schema.activityCategory = {
      activitySection: get(fields, 'activitySection.value'),
      parent: {
        id: get(fields, 'activityCategory.parent.id')
      },
      userDefined: true,
      name: get(fields, 'activityCategory.name')
    }
  } else {
    schema.activityCategory.id = get(fields, 'activityCategory.id')
  }

  return schema
}
